import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { SearchResultSkeleton } from '../search-result-skeleton';

const resultsListGridAreaStyles = xcss({
	gridArea: 'results-list',
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.200',
});

export const ResultsLoading = ({ rowCount = 7 }): React.JSX.Element => {
	return (
		<Box role="list" xcss={resultsListGridAreaStyles} testId="search-page-results-loading">
			{Array.from({ length: rowCount }).map((_, index) => (
				<SearchResultSkeleton key={index} />
			))}
		</Box>
	);
};
